export default "__VITE_ASSET__Hf5iB8Yv__"